import * as req from 'api/actions';
import * as c from './constant';

export const getNewBusinessNaturesList = (
  payload = { sort_by: 'desc' },
  callback
) =>
  req.list(
    c.GET_NEW_BUSINESS_NATURES,
    '/api/v1/bpls/administrator/business/natures',
    payload,
    callback
  );

export const getSingleNewBusinessNatures = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_NEW_BUSINESS_NATURES,
    `/api/v1/bpls/administrator/business/natures/${id}`,
    payload,
    callback
  );

export const createNewBusinessNatures = (payload, callback) =>
  req.create(
    c.CREATE_NEW_BUSINESS_NATURES,
    '/api/v1/bpls/administrator/business/natures',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateNewBusinessNatures = (id, payload, callback) =>
  req.update(
    c.UPDATE_NEW_BUSINESS_NATURES,
    `/api/v1/bpls/administrator/business/natures/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeNewBusinessNatures = (id, payload, callback) =>
  req.remove(
    c.REMOVE_NEW_BUSINESS_NATURES,
    `/api/v1/bpls/administrator/business/natures/${id}`,
    payload,
    callback
  );

// business lines

export const getNewBusinessLinesList = (id, payload, callback) =>
  req.list(
    c.GET_NEW_BUSINESS_LINES,
    `/api/v1/bpls/administrator/business/natures/${id}/lines`,
    payload,
    callback
  );

export const getSingleNewBusinessLines = (
  id,
  businessLinesId,
  payload,
  callback
) =>
  req.item(
    c.GET_SINGLE_NEW_BUSINESS_LINES,
    `/api/v1/bpls/administrator/business/natures/${id}/lines/${businessLinesId}`,
    payload,
    callback
  );

export const createNewBusinessLines = (id, payload, callback) =>
  req.create(
    c.CREATE_NEW_BUSINESS_LINES,
    `/api/v1/bpls/administrator/business/natures/${id}/lines`,
    payload,
    callback
  );

export const updateNewBusinessLines = (
  id,
  businessActivitiesId,
  payload,
  callback
) =>
  req.update(
    c.UPDATE_NEW_BUSINESS_LINES,
    `/api/v1/bpls/administrator/business/natures/${id}/lines/${businessActivitiesId}`,
    payload,
    callback
  );

export const removeNewBusinessLines = (
  id,
  businessActivitiesId,
  payload,
  callback
) =>
  req.remove(
    c.REMOVE_NEW_BUSINESS_LINES,
    `/api/v1/bpls/administrator/business/natures/${id}/lines/${businessActivitiesId}`,
    payload,
    callback
  );

// tax revenues list

export const getNewTaxRevenuesGarbageList = (payload, callback) =>
  req.list(
    c.GET_NEW_TAX_REVENUES_GARBAGE,
    `/api/v1/bpls/administrator/common/tax_revenues`,
    payload,
    callback
  );

export const getNewTaxRevenuesLicenseList = (payload, callback) =>
  req.list(
    c.GET_NEW_TAX_REVENUES_LICENSE,
    `/api/v1/bpls/administrator/common/tax_revenues`,
    payload,
    callback
  );

export const getNewTaxRevenuesPermitList = (payload, callback) =>
  req.list(
    c.GET_NEW_TAX_REVENUES_PERMIT,
    `/api/v1/bpls/administrator/common/tax_revenues`,
    payload,
    callback
  );

export const getNewTaxRevenuesSanitaryList = (payload, callback) =>
  req.list(
    c.GET_NEW_TAX_REVENUES_SANITARY,
    `/api/v1/bpls/administrator/common/tax_revenues`,
    payload,
    callback
  );

export const activateNewBusinessNatures = (id, payload, callback) =>
  req.update(
    c.ACTIVATE_NEW_BUSINESS_NATURES,
    `/api/v1/bpls/administrator/business/natures/${id}/activate`,
    payload,
    callback
  );

export const deactivateNewBusinessNatures = (id, payload, callback) =>
  req.update(
    c.DEACTIVATE_NEW_BUSINESS_NATURES,
    `/api/v1/bpls/administrator/business/natures/${id}/deactivate`,
    payload,
    callback
  );

export const activateNewBusinessLines = (
  id,
  businessActivitiesId,
  payload,
  callback
) =>
  req.update(
    c.ACTIVATE_NEW_BUSINESS_LINES,
    `/api/v1/bpls/administrator/business/natures/${id}/lines/${businessActivitiesId}/activate`,
    payload,
    callback
  );

export const deactivateNewBusinessLines = (
  id,
  businessActivitiesId,
  payload,
  callback
) =>
  req.update(
    c.DEACTIVATE_NEW_BUSINESS_LINES,
    `/api/v1/bpls/administrator/business/natures/${id}/lines/${businessActivitiesId}/deactivate`,
    payload,
    callback
  );

export const getBusinessLineOtherFeeList = (payload, callback) =>
  req.list(
    c.GET_BUSINESS_LINE_OTHER_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees_specific`,
    payload,
    callback
  );

export const getReportAccess = (payload, callback) =>
  req.create(
    c.GET_REPORT_ACCESS,
    '/api/v1/administrators/report_access_tokens',
    payload,
    callback
  );
